import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import type { NodeSpec } from './NodeSpec';

export const timestampUiNodeSpec: NodeSpec<NodeCfg<'timestamp'>> = {
    kindLabel: 'Timestamp',
    nodeCategory: 'timeAndDate',
    validator: () => true,
    controls: () => ({}),
    cfg: () => ({
        id: getUID(),
        kind: 'timestamp',
        controlValues: {},
    }),
    inputs: () => ({
        trigger: { socket: 'event', label: 'Trigger' },
    }),
    outputs: () => ({
        next: { socket: 'event', label: 'Next' },
        epoch: { socket: 'number', label: 'Unix Epoch' },
    }),
    requiredSockets: () => ({
        required: [ 'epoch' ],
        conditionallyRequired: [],
    }),
};
